"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("../helpers/utilities");
var Accordion = /** @class */ (function () {
    function Accordion() {
        this.config = {
            htmlElements: {
                accordion: null
            },
            nodeLists: {
                accordions: document.querySelectorAll('[data-accordion]'),
                btns: document.querySelectorAll('[data-accordion-btn]')
            },
            classNames: {
                active: 'accordion--active'
            },
            selectors: {
                btn: '[data-accordion-btn]',
                panel: '[data-accordion-panel]',
            }
        };
    }
    Accordion.prototype.init = function () {
        this.load();
        this.addEventListeners();
    };
    Accordion.prototype.load = function () {
        var _this = this;
        this.config.nodeLists.accordions.forEach(function (htmlElement) { return _this.openPanels(htmlElement); });
    };
    Accordion.prototype.addEventListeners = function () {
        var _this = this;
        this.config.nodeLists.accordions.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.handleAccordionClick.bind(_this, htmlElement)); });
    };
    Accordion.prototype.openPanels = function (htmlElement) {
        (0, utilities_1.openPanel)(htmlElement.querySelector(this.config.selectors.panel), htmlElement.classList.contains(this.config.classNames.active));
    };
    Accordion.prototype.handleAccordionClick = function (htmlElement, event) {
        var target = event.currentTarget;
        var enabled = !target.classList.contains('accordion--disabled');
        if (target && enabled) {
            this.toggleActiveClassName(htmlElement);
            this.openPanels(htmlElement);
        }
    };
    Accordion.prototype.toggleActiveClassName = function (htmlElement) {
        if (htmlElement.classList.contains(this.config.classNames.active)) {
            htmlElement.classList.remove(this.config.classNames.active);
        }
        else {
            htmlElement.classList.add(this.config.classNames.active);
        }
    };
    return Accordion;
}());
exports.default = new Accordion();
